import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import OpenInNewOutlinedIcon from 'components/material-symbol/icons/OpenInNew'
import {
  INCOMPLETE_STRIPE_SETUP_TIP,
  CHARGES_DISABLED_OR_ACCOUNT_DELETED_TIP,
  PAYOUTS_DISABLED_TIP,
} from 'utils/constants'
import useStyles from './styles'

const PaymentAccountWarning = ({
  paymentAccount,
  onOpen,
  hasUnresolvedPaymentAccount = false,
}) => {
  const classes = useStyles()
  const { detailsSubmitted, chargesEnabled, payoutsEnabled, deletedAt } =
    paymentAccount || {}
  const isDeletedPaymentAccount =
    deletedAt != null || hasUnresolvedPaymentAccount

  if (
    (!paymentAccount && !hasUnresolvedPaymentAccount) ||
    (paymentAccount && detailsSubmitted && chargesEnabled && payoutsEnabled)
  ) {
    return null
  }

  const ActionButton = () => {
    const handleOpen = event => {
      event.preventDefault()
      event.stopPropagation()
      onOpen()
    }

    return isDeletedPaymentAccount ? null : (
      <Button
        type="button"
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<OpenInNewOutlinedIcon fontSize="small" />}
        className={classes.actionButton}
        onMouseDown={handleOpen}
        onClick={handleOpen}
      >
        Complete Setup
      </Button>
    )
  }

  const getWarningBlocks = () => {
    const warningBlocks = []

    if (!detailsSubmitted && !isDeletedPaymentAccount) {
      warningBlocks.push(
        <Box
          key="details-not-submitted"
          className={`${classes.warningBox} ${classes.detailsNotSubmittedWarning}`}
        >
          <Typography variant="body1" className={classes.warningContent}>
            {INCOMPLETE_STRIPE_SETUP_TIP}
          </Typography>
          <ActionButton />
        </Box>,
      )
      return warningBlocks
    }

    if (!chargesEnabled || isDeletedPaymentAccount) {
      warningBlocks.push(
        <Box
          key="charges-not-enabled"
          className={`${classes.warningBox} ${classes.chargesDisabledWarning}`}
        >
          <Typography variant="body1" className={classes.warningContent}>
            {CHARGES_DISABLED_OR_ACCOUNT_DELETED_TIP}
          </Typography>
          <ActionButton />
        </Box>,
      )
    }
    if (!payoutsEnabled && !isDeletedPaymentAccount) {
      warningBlocks.push(
        <Box
          key="payouts-not-enabled"
          className={`${classes.warningBox} ${classes.payoutsDisabledWarning}`}
        >
          <Typography variant="body1" className={classes.warningContent}>
            {PAYOUTS_DISABLED_TIP}
          </Typography>
          <ActionButton />
        </Box>,
      )
    }

    return warningBlocks
  }

  return <>{getWarningBlocks()}</>
}

export default PaymentAccountWarning
